'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { isValidCampaignToken } from '@/lib/campaign-link'

/**
 * `?c=<token>` twin of `RefTracker` for campaign links that could not use the
 * `/c/<token>` redirect route. Unlike `booking_ref`, the `tk_c` cookie is
 * HttpOnly, so the browser cannot write it: this POSTs the token to
 * `/api/booking/campaign-click`, which records the click and sets the cookie,
 * then cleans the URL. Fire-and-forget; a failure only loses attribution.
 */
export function CampaignTracker({ token }: { token: string }) {
  const router = useRouter()

  useEffect(() => {
    if (!isValidCampaignToken(token)) return
    fetch('/api/booking/campaign-click', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
      keepalive: true,
    })
      .catch(() => undefined)
      .finally(() => router.replace('/'))
  }, [token, router])

  return null
}
